import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class PromotionDataService {

  constructor(private dataService: DataService) { }

  GetServiceProviderListForPromo() {
    return this.dataService.getRecord('/api/promotion/GetServiceProviderListForPromo');
  }

  saveManagePromotionDetails(payload) {
    return this.dataService.post('/api/promotion/saveManagePromotionDetails', payload);
  }
  getManagePromotionDetails() {
    return this.dataService.getRecord('/api/promotion/getManagePromotionDetails');
  }

  getManagePromotionDetailsbyId(id) {
    return this.dataService.getRecord('/api/promotion/getPromotionDetailById/' + id);
  }

  GetPromoBySearchQuery(payload) {
    return this.dataService.getRecordWithParams('/api/promotion/GetPromoBySearchQuery', payload);
  }

  GetSelectedSPProdList(payload) {
    return this.dataService.post('/api/promotion/getProdAndFeeListByServiceProviderId', payload);
  }

  deletePromoAndPromoProd(payload) {
    return this.dataService.post('/api/promotion/deletePromoAndPromoProd', payload);
  }

  getActivePromotions() {
    return this.dataService.getRecord('/api/promotion/getActivePromotions');
  }
  getPromoApplicationList(payload) {
    return this.dataService.post('/api/promotion/getPromoApplicationList', payload);
  }

  uploadRevokePromoList(payload: any) {
    return this.dataService.post('/api/promotion/uploadRevokePromoList', payload);
  }

  getRelocationPageAccessList() {
    return this.dataService.getRecord('/api/RetentionPromotion/getRelocationPageAccessList');
  }

  getRelocationPromotionDetails() {
    return this.dataService.getRecord('/api/RetentionPromotion/getRelocationPromotionList');
  }

  markRelocationPaymentAsPaid(data: any) {
    return this.dataService.post('/api/RetentionPromotion/markRelocationPaymentAsPaid', data);
  }

  getRelocationExport(IsAgentExport: any) {
    return this.dataService.getRecord('/api/RetentionPromotion/getRelocationPromoReport/?IsAgentExport=' + IsAgentExport);
  }
}
